export class DocumentRelativeOffset {

    /**
     * @param {String} selector
     * @return {{top: number, left: number, bottom: number, right: number}}
     */
    getBySelectorOffset(selector) {
        let element = document.querySelector(selector);
        return this._getOffset(element);
    }

    /**
     * @param {HTMLElement} element
     * @return {{top: number, left: number, bottom: number, right: number}}
     */
    getElementOffset(element) {
        return this._getOffset(element);
    }

    /**
     * @private
     * @param {HTMLElement} element
     * @return {{top: number, left: number, bottom: number, right: number}}
     */
    _getOffset(element) {
        let rect = element.getBoundingClientRect(),
            scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
            scrollTop = window.pageYOffset || document.documentElement.scrollTop
        ;
        return {
            top: rect.top + scrollTop,
            left: rect.left + scrollLeft,
            bottom: scrollTop + rect.top + rect.height,
            right: scrollLeft + rect.width,
        }
    }
}